import { useSnapshot } from 'valtio'
import { AppStore } from './store/store'
import Main from './pages/Main'
import Floor from './pages/Floor'
import BlockA from './pages/BlockA'
import BlockB from './pages/BlockB'

const App = () => {
  const { currentPage } = useSnapshot(AppStore)

  switch (currentPage) {
    case 10:
      return <Main />

    case 21:
      return <BlockA />

    case 22:
      return <BlockB />

    case 31:
      return <Floor />

    case 32:
      return <Floor />

    default:
      return <div className="loader_container"><div className="loader" /></div>
  }
}

export default App
